import React, { useEffect, useState } from 'react';
import "./index.scss";
import * as API from '../../configuration/apiconfig';

const DeliveryType = (props) => {
    const [selectedDeliveryType, setSelectedDeliveryType] = useState(null);

    const { fnbDataForTicketSummary, handleDeliveryTypeSelection, isLoading } = props;
    return (
        <div>
            <section className="delivery-type-container">
                <p className='delivery-type-description'>Some menu items can be delivered to your seat, while others
                    must be picked up from the concessions counter</p>
                <div className={`delivery-type-card to-be-picked-up ${selectedDeliveryType === "pickup" ? 'active' : ''}`} role='button' onClick={() => setSelectedDeliveryType("pickup")}>
                    <div className="delivery-type-card-header">
                        <img src={selectedDeliveryType === "pickup" ? '/assets/images/to-be-picked-up-active.png' : '/assets/images/to-be-picked-up.png'} alt="" className='delivery-type-image' />
                        <p className='delivery-type-label'>Picked Up at the Concessions Counter</p>
                    </div>
                    <div className="delivery-type-card-content">
                        <p className='delivery-note to-be-picked-up'>- All items will be ready immediately -</p>
                        <ul className='to-be-picked-up-items-list'
                            style={{ '--list-item-icon': "url('/assets/images/pick-up-list-item-icon.png')" }}
                        >
                            {
                                fnbDataForTicketSummary?.map((item) => {
                                    return (
                                        <li className="pickup">
                                            <span>{item.description}
                                            </span>
                                            <span>x{item.qty}</span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
                <div className={`delivery-type-card in-seat-delivery ${selectedDeliveryType === "inSeatDelivery" ? 'active' : ''}`} role='button' onClick={() => setSelectedDeliveryType("inSeatDelivery")}>
                    <div className="delivery-type-card-header">
                        <img src={selectedDeliveryType === "inSeatDelivery" ? '/assets/images/in-seat-delivery-active.png' : '/assets/images/in-seat-delivery.png'} alt="" className='delivery-type-image' />
                        <p className='delivery-type-label'>Deliver available items to your seat</p>
                    </div>
                    <div className="delivery-type-card-content">
                        <p className='delivery-note in-seat-delivery'>- Delivered to your seat -</p>
                        <ul className='in-seat-delivery-items-list'
                            style={{ '--list-item-icon': "url('/assets/images/in-seat-list-item-icon.png')" }}
                        >
                            {
                                fnbDataForTicketSummary?.filter(item => item.inSeatDelivery).map((item) => {
                                    return (
                                        <li className="pickup">
                                            <span>{item.description}
                                            </span>
                                            <span>x{item.qty}</span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    {
                        fnbDataForTicketSummary?.filter(item => item.pickupAtCounter).length > 0 &&
                        <div className="delivery-type-card-content to-be-picked-up-container">
                            <p className='delivery-note to-be-picked-up'>- Pick-up required at counter -</p>
                            <ul className='to-be-picked-up-items-list' style={{ '--list-item-icon': "url('/assets/images/pick-up-list-item-icon.png')" }}>
                                {
                                    fnbDataForTicketSummary?.filter(item => item.pickupAtCounter).map((item) => {
                                        return (
                                            <li className="pickup">
                                                <span>{item.description}
                                                </span>
                                                <span>x{item.qty}</span>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                            <p className='note'>
                                *These items require counter pick-up only
                            </p>
                        </div>
                    }
                </div>
                <button className="btn btnPrimary proceed-btn" disabled={!selectedDeliveryType || isLoading} onClick={() => handleDeliveryTypeSelection(selectedDeliveryType)} >Yes, Proceed</button>
            </section>
        </div>
    )
}

export default DeliveryType